module.exports = __webpack_public_path__ + "img/services-reports-red-450x300.3828c5b0.jpeg";